import type { Follow } from "@tandemdiabetes/sugarmate-api-react-client"

import { getFirstCharOrEmoji } from "./getFirstCharOrEmoji"

/*
 * displays the first name and last initial of the follower
 */
export function followToFollowerFirstAndLastInitial(follow: Follow): string {
  const first = follow.follower_firstname ?? ""
  const lastInitial = getFirstCharOrEmoji(
    follow.follower_lastname ?? "",
  ).toLocaleUpperCase()
  return `${first} ${lastInitial}`
}

/*
 * displays the first name and last name of the follower
 */
export function followToFollowerFull(follow: Follow): string {
  const first = follow.follower_firstname ?? ""
  const last = follow.follower_lastname ?? ""
  return `${first} ${last}`
}

/*
 * displays the nickname or the first name and last initial of the sharer
 */
export function followToSharerFirstAndLastInitial(follow: Follow): string {
  if (follow.nickname) {
    return follow.nickname
  }

  const first = follow.sharer_firstname ?? ""
  const lastInitial = getFirstCharOrEmoji(
    follow.sharer_lastname ?? "",
  ).toLocaleUpperCase()

  return `${first} ${lastInitial}`
}

/*
 * displays the nickname or the first name and last name of the sharer
 */
export function followToSharer(follow: Follow): string {
  if (follow.nickname) {
    return follow.nickname
  }

  return `${follow.sharer_firstname ?? ""} ${follow.sharer_lastname ?? ""}`
}

/*
 * displays the first name and last name of the sharer even if they have a
 * nickname
 */
export function followToSharerFull(follow: Follow): string {
  return `${follow.sharer_firstname ?? ""} ${follow.sharer_lastname ?? ""}`
}

/*
 * displays the first initial of the nickname or the first initials of the
 * first name and last name of the sharer
 */
export function followToSharerInitials(follow: Follow): string {
  if (follow.nickname) {
    return getFirstCharOrEmoji(follow.nickname).toLocaleUpperCase()
  }

  const firstInitial = getFirstCharOrEmoji(
    follow.sharer_firstname ?? "",
  ).toLocaleUpperCase()
  const lastInitial = getFirstCharOrEmoji(
    follow.sharer_lastname ?? "",
  ).toLocaleUpperCase()
  return `${firstInitial}${lastInitial}`
}
